var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficInfoGreenEce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_info_x5F_green_x5F_ece",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_info_x5F_green_x5F_ece_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "triangle_x5F_white",
    style: {
      fill: "#FFFFFF"
    },
    d: "M45.158,38.512L26.604,6.042C26.063,5.096,25.09,4.531,24,4.531 c-1.09,0-2.064,0.565-2.604,1.511L2.842,38.512c-0.537,0.938-0.533,2.058,0.009,2.993C3.394,42.441,4.364,43,5.446,43h37.107 c1.081,0,2.052-0.559,2.595-1.494S45.695,39.451,45.158,38.512z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "triangle_x5F_green",
    style: {
      fill: "#0F7217"
    },
    d: "M24,9.547L40.83,39H7.17L24,9.547 M24,5.531 c-0.676,0-1.353,0.336-1.736,1.008L3.71,39.008C2.948,40.341,3.911,42,5.446,42h37.107c1.536,0,2.498-1.659,1.736-2.992 L25.736,6.539C25.353,5.867,24.676,5.531,24,5.531L24,5.531z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "car_x5F_front_1_",
    d: "M32.333,30l-0.74-1.109C31.223,28.334,30.598,28,29.93,28H26.07c-0.669,0-1.293,0.334-1.664,0.891 L23.667,30H23v1v2v1v2h2v-2h6v2h2v-2v-1v-2v-1H32.333z M25.238,29.445C25.424,29.166,25.735,29,26.07,29h3.859 c0.335,0,0.646,0.166,0.832,0.445L31.798,31h-7.596L25.238,29.445z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "car_x5F_back_2_",
    d: "M26.07,26H28v-2v-1h-0.667l-0.74-1.109C26.223,21.334,25.598,21,24.93,21H21.07 c-0.669,0-1.293,0.334-1.664,0.891L18.667,23H18v1v2v1v2h2v-2h3.428C24.149,26.364,25.083,26,26.07,26z M19.202,24l1.036-1.555 C20.424,22.166,20.735,22,21.07,22h3.859c0.335,0,0.646,0.166,0.832,0.445L26.798,24H19.202z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficInfoGreenEce);
export default __webpack_public_path__ + "static/media/icon-traffic_info_green_ece.6340eabaa1ec4bbe9c3c6701ab753303.svg";
export { ForwardRef as ReactComponent };